var n=function(n){return null==n||""===n||" "===n};export{n as isEmpty};
//# sourceMappingURL=isEmpty.js.map
